import React, { useContext } from "react";
// router, intl
import { useIntl } from "react-intl";
import { useNavigate } from "react-router";
// ui
import classNames from "classnames";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
// component
import TopPanel from "./topPanel/TopPanel";
import { StoreContext } from "../../../../../store/StoreProvider";
import PersonalTabCtx from "./personalTabCtx/PersonalTabCtx";
import GroupTabCtx from "./groupTabCtx/GroupTabCtx";
import BottomPanel from "./bottomPanel/BottomPanel";
// hook
import useLocaleRoute from "../../../../../common/hooks/useLocaleRoute";
import useModulePublic from "../../../../hooks/useModulePublic";
// config,utils,css
import urls from "../../../../../api/project/ApiUrls";
import fireAuth from "../../../../../api/firebase/auth/utils";
import { MODULE_ID } from "../../../../../config/CONSTANTS";

const FileTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  const navigate = useNavigate();
  //
  const [state, dispatch] = useContext(StoreContext);
  const { user, sna } = state;
  const { locale } = user;
  const { sidebarFileTool } = sna;
  const { tabIdx } = sidebarFileTool;
  // hooks
  const { handleLocaleRoute } = useLocaleRoute(
    locale,
    urls?.locale_lang?.LOCALE_DEFAULT
  );
  const { handlePublic } = useModulePublic();
  //
  const isLoggedIn = fireAuth.isLoggedIn(user);
  // const isLoggedIn = true;

  const disabledPersonalTab = !handlePublic(MODULE_ID.snaSidebarFilePersonal);
  const disabledGroupTab = !handlePublic(MODULE_ID.snaSidebarFileGroup);

  const getTabCtx = () => {
    if (tabIdx === 0 && !disabledPersonalTab) return <PersonalTabCtx />;
    if (tabIdx === 1 && !disabledGroupTab) return <GroupTabCtx />;
    return null;
  };

  return (
    <Box>
      <Box pb={2}>
        <Typography
          textAlign="left"
          variant="body1"
          sx={{
            color: "#fff",
          }}
          className={classNames(
            "sna-sidebar__title",
            "sna-sidebar__title--file-tool"
          )}
        >
          {intl.formatMessage({
            id: "sna.sidebar.filetool.title",
            defaultMessage: "資料集",
          })}
        </Typography>
      </Box>
      <TopPanel />
      {getTabCtx()}
      <BottomPanel />
    </Box>
  );
};

export default FileTool;
